import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface InvoiceListInvoiceNumberHeaderProps
  extends HeaderContext<InvoiceModel, InvoiceModel['invoiceNumber']> {}

export const InvoiceListInvoiceNumberHeader =
  (): // props: InvoiceListInvoiceNumberHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-invoice.invoice-number');
  };
